import React from 'react'
import PropTypes from 'prop-types'
import {Layout} from 'antd'
import {LeftOutlined} from '@ant-design/icons'
import {Link} from 'react-router-dom'
import get from 'lodash.get'
import Navigation from './Navigation'

const Mobile = ({
  title,
  defaultBackTo,
  collapsed,
  toggleCollapse,
  children,
  location,
}) => {
  const backTo = get(location, 'state.backTo', defaultBackTo)

  return (
    <Layout className="layout mobile">
      <Layout>
        <Layout.Header className="layout-header">
          {collapsed ? (
            <React.Fragment>
              {backTo ? (
                <Link to={backTo}><LeftOutlined /></Link>
              ) : <i />}
              <span className="layout-title">{title}</span>
            </React.Fragment>
          ) : <span />}

          <div onClick={toggleCollapse} className="menu-button">&#9776;</div>
        </Layout.Header>

        <Layout.Content className="content">
          {children}
        </Layout.Content>
      </Layout>

      <Layout.Sider
        collapsible
        trigger={null}
        collapsed={collapsed}
        collapsedWidth={0}
        width={300}
        breakpoint="lg"
      >
        <Navigation
          location={location}
          collapsed={collapsed}
          toggleCollapse={toggleCollapse}
        />
      </Layout.Sider>
    </Layout>
  )
}

Mobile.propTypes = {
  location: PropTypes.object.isRequired,
  toggleCollapse: PropTypes.func.isRequired,
  title: PropTypes.string,
  defaultBackTo: PropTypes.string,
}

export default Mobile
